var $carousel = $('.js-practices-carousel'),
  $industriesBelt = $('.js-industries-carousel-belt'),
  $carouselBelt,
  $prevBtn,
  $nextBtn,
  $tabClicked;

  if (!$carousel.length) return;

  $carouselBelt = $carousel.find('.js-practices-carousel-belt')
  $prevBtn = $('.js-practices-carousel-arrow-prev')
  $nextBtn = $('.js-practices-carousel-arrow-next')
  $tabClicked = $('.js-tabs-nav-link');

  $carouselBelt.not('.slick-initialized').slick({
    slide: '.js-practices-carousel-slide',
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 768,
        settings: 'unslick'
      }
    ]
  });

  $prevBtn.click(function() {
    $carouselBelt.slick('slickPrev')
  })

  $nextBtn.click(function() {
    $carouselBelt.slick('slickNext')
  })

  $tabClicked.click(function() {
    $industriesBelt.slick('destroy');
    $carouselBelt.slick('reinit');
  })

  $(window).on('resize', function() {
    $carouselBelt.slick('resize');
  })